import React from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import messages from '../../js/utils/text-resources/rahalaitos/FI/messages';
import Clock from './SvgIcon/icons/Clock';

const Wrapper = styled.div`
  display: flex;
  max-height: 2.5rem;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  background: linear-gradient(90deg, #7CA8EF 0%, #AA91FF 100%);
  color: white;
  border-radius: 0.5rem;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 1rem;
`;

const Text = styled.div`
  margin-left: 0.5rem;
`;

const Clockbanner = ({ intl: { formatMessage } }) => {
  const isFeatureOn = useFeatureIsOn('clockBanner');

  if (!isFeatureOn) {
    return null;
  }

  return (
    <Wrapper>
      <Clock />
      <Text>{formatMessage(messages.clockBanner)}</Text>
    </Wrapper>
  );
};

Clockbanner.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(Clockbanner);
